export const NOTIFICATION_MESSAGE_INFO = 'info';
export const NOTIFICATION_MESSAGE_SUCCESS = 'success';
export const NOTIFICATION_MESSAGE_WARNING = 'warning';
export const NOTIFICATION_MESSAGE_ERROR = 'error';

export type NotificationMessageType =
  | typeof NOTIFICATION_MESSAGE_INFO
  | typeof NOTIFICATION_MESSAGE_SUCCESS
  | typeof NOTIFICATION_MESSAGE_WARNING
  | typeof NOTIFICATION_MESSAGE_ERROR;

export interface NotificationMessage {
  text: string;
  type: NotificationMessageType;
}
